// extracted by mini-css-extract-plugin
export var container = "layout-module--container--JXPvi";
export var fadeIn = "layout-module--fadeIn--kDEt9";
export var footer = "layout-module--footer--2E5ex";